import axios from 'axios'
import React from 'react'
import { baseUrl } from '../assets/Animations'
import './student-modal-2023.css'
import { MdClose } from 'react-icons/md'
import LeftGutterStudentModal2023 from './Gutters/LeftGutterStudentModal2023/LeftGutterStudentModal2023'
import CenterGutterStudentModal2023 from './Gutters/CenterGutterStudentModal2023/CenterGutterStudentModal2023'
import { getRequestHeaders } from '../api'
import NoteAreaFall2023 from '../StudentOnboardingCardModalFall2023/NoteAreaFall2023/NoteAreaFall2023'

const StudentModal2023 = ({familyId, setStudentModal2023, userData, createNoteFunc, deleteFamilyFromState}) => {
    const [family, setFamily] = React.useState({})
    const [instrumentList, setInstrumentList] = React.useState([])
    const [teachers, setTeachers] = React.useState([])
    const [cancellations, setCancellations] = React.useState([])

    React.useEffect(() => {
        getFamilyInfo()
        getInstrumentList()
        getFamilyCancellations()
    }, [])

    React.useEffect(() => {
        if(family.familyId) {
            getSchoolsTeachers(family.school)
            setStudentModal2023(family)
        }
    }, [family])

    const closeAndSaveModal = (id) => {
        if(id === 'student-modal-2023__wrapper') {
            axios.put(`${baseUrl}/school-management/${family.familyId}`, family, getRequestHeaders())
            .then(res => {
                setStudentModal2023(false)
            })
            .catch(err => console.log(err))
        }
    }

    const closeAndDeleteModal = () => {
        axios.delete(`${baseUrl}/school-management/${family.familyId}`, getRequestHeaders())
        .then(res => {
            setStudentModal2023(false)
        })
        .catch(err => console.log(err))
    }

    const getFamilyInfo = async () => {
        axios.get(`${baseUrl}/school-management/${familyId}`, getRequestHeaders())
        .then(res => {
            setFamily(res.data)
        })
        .catch(err => console.log(err))
    }

    const getSchoolsTeachers = async (school) => {
        await axios.get(`${baseUrl}/teachersbyschool/${school.toLowerCase()}`, getRequestHeaders())
        .then(res => {
            res.data.sort((a, b) => {
                let nameA = a.Name.toUpperCase()
                let nameB = b.Name.toUpperCase()
                if(nameA < nameB) {
                    return -1
                }
                if(nameA > nameB) {
                    return 1
                }
                return 0
            })
            setTeachers(res.data)
        })
        .catch(err => console.log(err))
    }

    const getInstrumentList = async () => {
        await axios.get(`${baseUrl}/inst`, getRequestHeaders())
        .then(res => {
            //alphabetize instrument list
            res.data.sort((a, b) => {
                let nameA = a.name.toUpperCase()
                let nameB = b.name.toUpperCase()
                if(nameA < nameB) {
                    return -1
                }
                if(nameA > nameB) {
                    return 1
                }
                return 0
            })
            setInstrumentList(res.data)
        })
        .catch(err => console.log(err))
    }

    const getFamilyCancellations = async () => {
        await axios.get(`${baseUrl}/cancellation/family/${familyId}`, getRequestHeaders())
        .then(res => {
            setCancellations(res.data)
        })
        .catch(err => console.log(err))
    }

    return (
        <div className='student-modal-2023__wrapper' id='student-modal-2023__wrapper' onClick={(e) => closeAndSaveModal(e.target.id)}>
            <div className='student-modal-2023__modal-system' id="student-modal-2023__modal-system" >
                <div className='student-modal-2023__x-column'>
                    <div className='student-modal-2023__x-column__x-wrapper' onClick={() => closeAndSaveModal('student-modal-2023__wrapper')}>
                        <MdClose size={23} color='#334155' />
                    </div>
                </div>
                {family.familyId ? <LeftGutterStudentModal2023 family={family} setFamily={setFamily} deleteFamilyFromState={deleteFamilyFromState} /> : <div>loading</div>}
                {family.familyId ? <CenterGutterStudentModal2023 
                    family={family} 
                    setFamily={setFamily}
                    instrumentList={instrumentList} 
                    teachers={teachers} 
                    cancellations={cancellations}
                /> : <div>loading</div>}
                <div className='student-modal-2023__right-gutter'>
                {family.familyId && <NoteAreaFall2023 
                    modalInfo={{id: family.familyId, type: 'familyId', displayName: family.familyId}}  
                    userData={userData} 
                    createNoteFunc={createNoteFunc} 
                    school={family.school.toLowerCase()}
                />}
                </div>
            </div>
        </div>
    )
}
export default StudentModal2023